interface Props {
	iconColor?: string;
	width?: string;
	height?: string;
}
const DoubleArrowPrev = ({ iconColor = '#868E96', width = '24', height = '24' }: Props) => (
	<svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M17 19L10.8485 12.8485C10.3799 12.3799 10.3799 11.6201 10.8485 11.1515L17 5" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round" />
		<path d="M13 19L6.84853 12.8485C6.3799 12.3799 6.3799 11.6201 6.84853 11.1515L13 5" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round" />
	</svg>
);

export default DoubleArrowPrev;
